/* eslint-disable @typescript-eslint/no-explicit-any */
import { BASE_URL, BASE_NET_URL_MOD, BASE_NET_URL_PACE, BASE_JAVA_URL_MOD } from './constants/api.constants';
import axios from 'axios';

class Api {
  generateFullUrl(url: string) {
    const urlObj = new URL(`${BASE_URL}${url}`);
    return urlObj.toString();
  }

  generateJavaFullUrl(url: string) {
    const urlObj = new URL(`${BASE_JAVA_URL_MOD}${url}`);
    return urlObj.toString();
  }

  generateFullNetPaceUrl(url: string) {
    const urlObj = new URL(`${BASE_NET_URL_PACE}${url}`);
    return urlObj.toString();
  }

  generateFullNetModUrl(url: string) {
    const urlObj = new URL(`${BASE_NET_URL_MOD}${url}`);
    return urlObj.toString();
  }

  get = async (url: string, isNet = false, isMod = false) => {
    const response = await axios.get(
      !isNet ? this.generateFullUrl(url) : isMod ? this.generateFullNetModUrl(url) : this.generateFullNetPaceUrl(url)
    );
    return response.data;
  };

  post = async (url: string, payload: any, params?: any, isNet = false, isMod = false) => {
    const response = await axios.post(
      !isNet ? this.generateFullUrl(url) : isMod ? this.generateFullNetModUrl(url) : this.generateFullNetPaceUrl(url),
      payload,
      {
        params,
      }
    );
    return response.data;
  };

  delete = async (url: string, payload?: any, isNet = false, isMod = false) => {
    const response = await axios.delete(
      !isNet ? this.generateFullUrl(url) : isMod ? this.generateFullNetModUrl(url) : this.generateFullNetPaceUrl(url),
      {
        data: payload,
      }
    );
    return response.data;
  };

  put = async (url: string, payload: any, params?: any, isNet = false, isMod = false) => {
    const response = await axios.put(
      !isNet ? this.generateFullUrl(url) : isMod ? this.generateFullNetModUrl(url) : this.generateFullNetPaceUrl(url),
      payload,
      {
        params,
      }
    );
    return response.data;
  };

  patch = async (url: string, payload?: any, isNet = false, isMod = false) => {
    const response = await axios.patch(
      !isNet ? this.generateFullUrl(url) : isMod ? this.generateFullNetModUrl(url) : this.generateFullNetPaceUrl(url),
      payload
    );
    return response.data;
  };

  // Temporary Change
  getAPI = async (url: string, isNet = false, isMod = false) => {
    const response = await axios.get(this.generateJavaFullUrl(url));
    return response.data;
  };

  postAPI = async (url: string, payload: any, params?: any, isNet = false, isMod = false) => {
    const response = await axios.post(this.generateJavaFullUrl(url), payload, {
      params,
    });
    return response.data;
  };

  deleteAPI = async (url: string, payload?: any, isNet = false, isMod = false) => {
    const response = await axios.delete(this.generateJavaFullUrl(url), {
      data: payload,
    });
    return response.data;
  };

  putAPI = async (url: string, payload: any, params?: any, isNet = false, isMod = false) => {
    const response = await axios.put(this.generateJavaFullUrl(url), payload, {
      params,
    });
    return response.data;
  };

  patchAPI = async (url: string, payload?: any, isNet = false, isMod = false) => {
    const response = await axios.patch(this.generateJavaFullUrl(url), payload);
    return response.data;
  };

  /* downloadFile = async (url: string, payload: any, method?) => {
    const { fileName, type, ...data } = payload;

    const response = await axios({
      url: this.generateFullUrl(url),
      data,
      method: method || 'POST',
      responseType: 'blob',
    });
    const contentType = response.headers['content-type'];

    if (response.status == 200 && contentType?.includes('text/plain')) {
      const errorText = await blobToText(response.data);
      return { success: false, error: errorText };
    }

    const Url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = Url;
    link.setAttribute('download', `${fileName || 'file'}.${type || 'xlsx'}`);
    document.body.appendChild(link);
    link.click();
  }; */

  downloadFile = async (url: string, payload: any, method?: string) => {
    const { fileName, type, ...data } = payload;

    const response = await axios({
      url: this.generateFullUrl(url),
      data,
      method: method || 'POST',
      responseType: 'blob',
    });

    const contentType = response.headers['content-type'];

    // Handle backend returning error as plain text
    if (response.status === 200 && contentType?.includes('text/plain')) {
      const errorText = await blobToText(response.data);
      return { success: false, error: errorText };
    }

    let finalName = `${fileName || 'file'}.${type || 'xlsx'}`;
    const disposition = response.headers['content-disposition'];
    if (!fileName && disposition && disposition.includes('filename=')) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        finalName = decodeURIComponent(match[1]);
      }
    }

    // Create blob and trigger download
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', finalName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  };

  downloadResourceFile = async (url: string, payload: any, method?) => {
    const { fileName, type, ...data } = payload;

    const formdata = new FormData();
    formdata.append('blobUrl', payload.address);
    const response = await axios.post(this.generateFullUrl(url), formdata, {
      responseType: 'arraybuffer',
    });
    const fileBlob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    const burl = window.URL.createObjectURL(fileBlob);
    link.href = burl;
    const contentDisposition = response.headers['content-disposition'];
    let filename = payload.name;

    if (contentDisposition) {
      const matches = contentDisposition.match(/filename="(.+)"/);
      if (matches && matches[1]) {
        filename = matches[1];
      }
    }
    filename = decodeURIComponent(filename).replace(/\+/g, ' ');
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(burl);
  };

  //Temporary
  downloadJavaFile = async (url: string, payload: any, method?: string) => {
    const { fileName, type, ...data } = payload;

    const response = await axios({
      url: this.generateJavaFullUrl(url),
      data,
      method: method || 'POST',
      responseType: 'blob',
    });

    const contentType = response.headers['content-type'];

    // Handle backend returning error as plain text
    if (response.status === 200 && contentType?.includes('text/plain')) {
      const errorText = await blobToText(response.data);
      return { success: false, error: errorText };
    }

    let finalName = `${fileName || 'file'}.${type || 'xlsx'}`;
    const disposition = response.headers['content-disposition'];
    if (!fileName && disposition && disposition.includes('filename=')) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        finalName = decodeURIComponent(match[1]);
      }
    }

    // Create blob and trigger download
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', finalName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  };

  downloadResourceJavaFile = async (url: string, payload: any, method?) => {
    const { fileName, type, ...data } = payload;

    const formdata = new FormData();
    formdata.append('blobUrl', payload.address);
    const response = await axios.post(this.generateJavaFullUrl(url), formdata, {
      responseType: 'arraybuffer',
    });
    const fileBlob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    const burl = window.URL.createObjectURL(fileBlob);
    link.href = burl;
    const contentDisposition = response.headers['content-disposition'];
    let filename = payload.name;

    if (contentDisposition) {
      const matches = contentDisposition.match(/filename="(.+)"/);
      if (matches && matches[1]) {
        filename = matches[1];
      }
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(burl);
  };
}

const blobToText = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsText(blob);
  });
};
export default new Api();
